import React from "react";
import { Button, Card, List, Alert, Typography, Flex} from "antd";
import {
    DeleteOutlined, UserOutlined, HistoryOutlined,
    EnvironmentOutlined, CreditCardOutlined,
    MailOutlined, CheckCircleOutlined, UnorderedListOutlined,
} from "@ant-design/icons";
import TopNavigation from "./snipets/TopNavigation";
import Footer        from "./snipets/Footer";

const { Title, Text } = Typography;

const steps = [
    { icon: <UserOutlined />,           title: "Open your Profile",       description: 'Tap the "Profile" tab at the bottom of the app screen.' },
    { icon: <UnorderedListOutlined />,  title: 'Scroll to "More" section', description: 'Scroll down past your account settings to find the "More" section.' },
    { icon: <DeleteOutlined />,         title: 'Tap "Delete Account"',    description: 'Tap the red "Delete Account" option. You will see a warning that this action is permanent.' },
    { icon: <CheckCircleOutlined />,    title: "Confirm Deletion",        description: "Confirm your choice in the dialog. Your account and all associated data will be permanently deleted." },
];

const deletedItems = [
    { icon: <UserOutlined />,          text: "Your profile and personal information" },
    { icon: <HistoryOutlined />,       text: "Your order history"                   },
    { icon: <EnvironmentOutlined />,   text: "Your saved addresses"                 },
    { icon: <CreditCardOutlined />,    text: "Your payment methods"                 },
];

const DeleteAccountPage: React.FC = () => (
    <>
        <TopNavigation />

        <Flex justify="center" style={{ background: "#f5f5f0", minHeight: "100vh", padding: "80px 16px 40px" }}>
            <Flex vertical gap={16} style={{ width: "100%", maxWidth: 560 }}>

                {/* Header card */}
                <Card style={{ borderTop: "4px solid #FF3D71" }}>
                    <Flex gap={14} align="center" style={{ marginBottom: 12 }}>
                        <div style={{
                            width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                            background: "#FFF0F3", border: "1.5px solid #FFB3C1",
                            display: "flex", alignItems: "center", justifyContent: "center",
                        }}>
                            <DeleteOutlined style={{ color: "#FF3D71", fontSize: 20 }} />
                        </div>
                        <div>
                            <Title level={4} style={{ margin: 0 }}>Delete Your Account</Title>
                            <Text type="secondary" style={{ fontSize: 13 }}>Delivery Quick Quick</Text>
                        </div>
                    </Flex>
                    <Alert
                        type="warning"
                        showIcon
                        message={<><Text strong>This action is permanent and cannot be undone.</Text> All your orders, account data, and personal information will be deleted.</>}
                    />
                </Card>

                {/* Steps card */}
                <Card>
                    <Text style={{ fontSize: 11, fontWeight: 700, color: "#00AF66", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 18 }}>
                        How to Delete In the App
                    </Text>
                    {steps.map((step, index) => (
                        <Flex key={index} gap={14} align="flex-start" style={{ marginBottom: index < steps.length - 1 ? 20 : 0 }}>
                            <Flex vertical align="center" style={{ flexShrink: 0 }}>
                                <div style={{
                                    width: 36, height: 36, borderRadius: 10,
                                    background: "#E6F7EF", border: "1.5px solid #BFEAD8",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    color: "#00AF66", fontSize: 15,
                                }}>
                                    {step.icon}
                                </div>
                                {index < steps.length - 1 && (
                                    <div style={{ width: 2, height: 20, background: "#EDF1F7", marginTop: 4 }} />
                                )}
                            </Flex>
                            <div style={{ paddingTop: 4 }}>
                                <Text strong style={{ fontSize: 14, display: "block" }}>{index + 1}. {step.title}</Text>
                                <Text type="secondary" style={{ fontSize: 13, lineHeight: 1.5 }}>{step.description}</Text>
                            </div>
                        </Flex>
                    ))}
                </Card>

                {/* What gets deleted */}
                <Card>
                    <Text style={{ fontSize: 11, fontWeight: 700, color: "#00AF66", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 14 }}>
                        What Gets Deleted
                    </Text>
                    <List
                        dataSource={deletedItems}
                        renderItem={(item, i) => (
                            <List.Item style={{ borderBottom: i < deletedItems.length - 1 ? undefined : "none", padding: "8px 0" }}>
                                <List.Item.Meta
                                    avatar={<span style={{ color: "#FF3D71" }}>{item.icon}</span>}
                                    description={<Text>{item.text}</Text>}
                                />
                            </List.Item>
                        )}
                    />
                </Card>

                {/* Need help */}
                <Card>
                    <Flex justify="space-between" align="center">
                        <div>
                            <Text strong style={{ fontSize: 14, display: "block" }}>Need help instead?</Text>
                            <Text type="secondary" style={{ fontSize: 13 }}>Contact our support team</Text>
                        </div>
                        <Button
                            icon={<MailOutlined />}
                            onClick={() => window.location.href = "mailto:support@deliveryquickquick.co.za"}
                        >
                            Contact Us
                        </Button>
                    </Flex>
                </Card>

            </Flex>
        </Flex>

        <Footer />
    </>
);

export default DeleteAccountPage;